import { useIsCuaLeanObservationEnabled } from '@/app-shell/flags/cua-lean-observation-flag';
import { logger } from '@/utils/logger/logger';
import { rpaBridge } from '@heidi/plugin-rpa';
import { useEffect } from 'react';

export const useSyncCuaLeanObservation = (): void => {
  const enabled = useIsCuaLeanObservationEnabled();

  useEffect(() => {
    if (!rpaBridge.isAvailable()) return;
    rpaBridge.setLeanObservation(enabled).catch((error: unknown) => {
      logger.warn('[cua-lean-observation] Failed to push the observation flag', {
        error_kind: error instanceof Error ? error.name : typeof error,
      });
    });
  }, [enabled]);
};
